import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Table, Card } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaSave, FaTrash, FaPenSquare } from "react-icons/fa";

export default function ModalLancamentoManual({ show, onHide, dataInicio, dataFim, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [lancamentos, setLancamentos] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });

    const [form, setForm] = useState({
        roteamento: '', bandeira: '', condicao: '', loja: '',
        datavenda: new Date().toISOString().split('T')[0],
        datacredito: new Date().toISOString().split('T')[0],
        valorbruto: '', taxaflor: 0
    });

    const formatarMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            useGrouping: true
        }).format(Number(valor || 0));
    };

    const [filtros, setFiltros] = useState({
        dtini: dataInicio,
        dtfim: dataFim
    });

    useEffect(() => {
        if (show) {
            setForm(initialState);
            setLancamentos([]);
            api.get('/financeiro/conciliacao/roteamentos')
                .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
                .catch(err => console.error("Erro roteamentos:", err));
        }
    }, [show]);

    const renderOptions = (lista, campo) => {
        return lista.map((item, index) => {
            const valor = typeof item === 'object' ? item[campo] : item;
            return <option key={index} value={valor}>{valor}</option>;
        });
    };

    const initialState = {
        roteamento: '',
        bandeira: '',
        condicao: '',
        loja: '',
        datavenda: new Date().toISOString().split('T')[0],
        datacredito: new Date().toISOString().split('T')[0],
        valorbruto: '',
        taxaflor: 0
    };

    const atualizarLista = async () => {
        if (!form.roteamento) return;
        try {
            const res = await api.get('/financeiro/conciliacao/manual/listar', {
                params: {
                    dtini: formatarDataBR(dataInicio),
                    dtfim: formatarDataBR(dataFim),
                    roteamento: form.roteamento,
                    bandeira: form.bandeira || '',
                    condicao: form.condicao || ''
                }
            });
            setLancamentos(res.data);
        } catch (err) {
            console.error("Erro ao listar:", err);
        }
    };

    const handleExcluir = async (item) => {
        const confirmacao = await Swal.fire({
            title: 'Excluir Lançamento?',
            text: "Esta ação não pode ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (!confirmacao.isConfirmed) return;

        try {
            setLoading(true);
            await api.delete('/financeiro/conciliacao/manual', {
                params: {
                    dtini: formatarDataBR(item.DATAVENDA || item.datavenda),
                    dtfim: formatarDataBR(item.DATAVENDA || item.datavenda),
                    roteamento: item.ROTEAMENTO || item.roteamento || form.roteamento,
                    bandeira: item.BANDEIRA || item.bandeira,
                    condicao: item.CONDICAO || item.condicao,
                    loja: item.LOJA || item.loja
                }
            });

            Swal.fire("Sucesso", "Lançamento excluído!", "success");
            atualizarLista();
        } catch (err) {
            Swal.fire("Erro", "Falha ao excluir: " + (err.response?.data?.erro || "Erro interno"), "error");
        } finally {
            setLoading(false);
        }
    };

    const handleSalvar = async () => {
        if (!form.roteamento || !form.loja || !form.valorbruto || !form.datavenda || !form.datacredito) {
            Swal.fire("Erro", "Preencha todos os campos obrigatórios.", "error");
            return;
        }

        setLoading(true);

        const payload = {
            ...form,
            datavenda: formatarDataBR(form.datavenda),
            datacredito: formatarDataBR(form.datacredito)
        };

        try {
            await api.post('/financeiro/conciliacao/manual', payload);
            Swal.fire("Sucesso", "Lançamento realizado!", "success");
            atualizarLista();
            setForm({ ...form, valorbruto: '' });
        } catch (err) {
            Swal.fire("Erro", "Falha ao salvar: " + (err.response?.data?.error || "Erro interno"), "error");
        } finally {
            setLoading(false);
        }
    };

    const handleRoteamento = async (val) => {
        setForm({ ...form, roteamento: val, bandeira: '', condicao: '', taxaflor: 0 });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) { console.error(err); }
    };

    const handleBandeira = async (val) => {
        setForm(prev => ({ ...prev, bandeira: val, condicao: '', taxaflor: 0 }));
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) { console.error(err); }
    };

    const handleCondicao = async (val) => {
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/taxa?roteamento=${form.roteamento}&bandeira=${form.bandeira}&condicao=${val}`);
            const valorTaxa = res.data.TAXA || res.data.taxa || 0;
            setForm(prev => ({ ...prev, condicao: val, taxaflor: valorTaxa }));
        } catch (err) { console.error(err); }
    };

    const formatarDataBR = (valor) => {
        if (!valor) return '';

        if (typeof valor === 'string' && valor.includes('GMT')) {
            const d = new Date(valor);
            if (!isNaN(d)) {
                const dia = String(d.getDate()).padStart(2, '0');
                const mes = String(d.getMonth() + 1).padStart(2, '0');
                const ano = d.getFullYear();
                return `${dia}/${mes}/${ano}`;
            }
        }

        if (valor instanceof Date) {
            const dia = String(valor.getDate()).padStart(2, '0');
            const mes = String(valor.getMonth() + 1).padStart(2, '0');
            const ano = valor.getFullYear();
            return `${dia}/${mes}/${ano}`;
        }

        const s = String(valor).trim();

        if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) {
            return s.substring(0, 10);
        }

        if (s.includes('-')) {
            const parts = s.split('T')[0].split('-');
            if (parts.length === 3) {
                const [y, m, d] = parts;
                return `${d}/${m}/${y}`;
            }
        }

        return s;
    };

    useEffect(() => {
        if (form.roteamento) {
            atualizarLista();
        } else {
            setLancamentos([]);
        }
    }, [form.roteamento, form.bandeira, form.condicao, filtros.dtini, filtros.dtfim]);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            {/* Cabeçalho alinhado com o degradê do menu */}
            <Modal.Header 
                closeButton 
                style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} 
                className="py-2 px-3 border-0"
            >
                <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2 text-white">
                    <FaPenSquare /> LANÇAMENTO MANUAL
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light p-3">
                <Card className="p-3 shadow-sm border-0 rounded-3 mb-3">
                    <Row className="g-2">
                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Roteamento</Form.Label>
                            <Form.Select size="sm" value={form.roteamento} onChange={e => handleRoteamento(e.target.value)}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.roteamentos, 'ROTEAMENTO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Bandeira</Form.Label>
                            <Form.Select size="sm" value={form.bandeira} onChange={e => handleBandeira(e.target.value)} disabled={!form.roteamento}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.bandeiras, 'BANDEIRA')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Condição</Form.Label>
                            <Form.Select size="sm" value={form.condicao} onChange={e => handleCondicao(e.target.value)} disabled={!form.bandeira}>
                                <option value="">Selecione...</option>
                                {renderOptions(lookups.condicoes, 'CONDICAO')}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Loja</Form.Label>
                            <Form.Control size="sm" type="number" value={form.loja} onChange={e => setForm({ ...form, loja: e.target.value })} />
                        </Col>

                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Data Venda</Form.Label>
                            <Form.Control
                                size="sm"
                                type="date"
                                value={form.datavenda}
                                onChange={e => setForm({ ...form, datavenda: e.target.value })}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Data Crédito</Form.Label>
                            <Form.Control
                                size="sm"
                                type="date"
                                value={form.datacredito}
                                onChange={e => setForm({ ...form, datacredito: e.target.value })}
                            />
                        </Col>

                        <Col md={2}>
                            <Form.Label className="small fw-bold text-secondary mb-1">Valor Bruto</Form.Label>
                            <Form.Control size="sm" type="number" value={form.valorbruto} onChange={e => setForm({ ...form, valorbruto: e.target.value })} />
                        </Col>
                        <Col md={2}>
                            <Form.Label className="small fw-bold text-danger mb-1">Taxa (%)</Form.Label>
                            <div className="form-control form-control-sm bg-light fw-bold text-center text-danger border-danger">{form.taxaflor}%</div>
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            <Button 
                                size="sm" 
                                style={{ backgroundColor: '#8b0000', borderColor: '#8b0000' }} 
                                className="w-100 fw-bold text-white d-flex align-items-center justify-content-center gap-1 shadow-sm" 
                                onClick={handleSalvar} 
                                disabled={loading}
                            >
                                <FaSave /> GRAVAR
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                    <div className="table-responsive" style={{ maxHeight: '300px' }}>
                        <Table striped bordered hover size="sm" className="small text-center mb-0 align-middle">
                            <thead className="table-secondary sticky-top">
                                <tr>
                                    <th>Loja</th>
                                    <th>Data Venda</th>
                                    <th>Data Crédito</th>
                                    <th>Valor Bruto</th>
                                    <th>Taxa %</th>
                                    <th>Valor Taxa</th>
                                    <th width="60">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lancamentos.map((l, i) => (
                                    <tr key={i}>
                                        <td>{l.LOJA || l.loja}</td>
                                        <td>{formatarDataBR(l.DATAVENDA || l.datavenda)}</td>
                                        <td>{formatarDataBR(l.DATACREDITO || l.datacredito)}</td>
                                        <td>{formatarMoeda(l.VALORBRUTO || l.valorbruto || 0)}</td>
                                        <td>{Number(l.TAXA || l.taxa || 0).toFixed(2)}%</td>
                                        <td className="text-danger fw-bold">{formatarMoeda(l.VALORTAXA || l.valortaxa || 0)}</td>
                                        <td>
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                className="py-0 px-2"
                                                onClick={() => handleExcluir(l)}
                                                title="Excluir este lançamento"
                                            >
                                                <FaTrash size={12} />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                {lancamentos.length === 0 && (
                                    <tr>
                                        <td colSpan="7" className="py-4 text-muted text-center">Nenhum lançamento encontrado.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card>
            </Modal.Body>
        </Modal>
    );
}